// - create button on top
// - Name, subject
// - Updated date
// - Actions: edit and delete

import React, { useEffect, useState } from 'react'
import { Button, Table } from 'reactstrap'
import EmailLayout from '../../components/Email/EmailLayout'
import CAlert from '../../components/sharedComponents/CAlert'
import { deleteEmailTemplate, getEmailTemplates } from '../../actions/emailTemplateAction'
import { Redirect } from 'react-router'
import { emailCreateTemplateLink, getEmailEditTemplateLink } from '../../routeLinks'
import { renderTemplateDetailsCol } from './emailSharedFuncs'
import { getUsers } from '../../actions/usersActions'

const EmailTemplateList = ({ }) => {

    const [templateList, setTemplateList] = useState([])
    const [userList, setUserList] = useState([])
    const [isLoading, setIsloading] = useState(false)
    const [errorText, setErrorText] = useState(null)
    const [redirectTo, setRedirectTo] = useState(null)
    const [isDeleted, setIsDeleted] = useState(false)

    useEffect(() => {
        setIsloading(true)

        const fetchData = async () => {
            await getEmailTemplates(setTemplateList, renderError)
            await getUsers(setUserList, renderError)
        }
        fetchData();

        setIsloading(false)
    }, [])

    function renderError(err) {
        setErrorText(err)
        isLoading && setIsloading(false)
        return
    }

    if (redirectTo && redirectTo !== '') {
        return <Redirect to={redirectTo} />
    }

    return <EmailLayout title='Email Template List' isLoading={isLoading} fixHeight>
        <CAlert show={errorText !== null} text={errorText} color='danger' />
        <CAlert onClick={() => setIsDeleted(false)} show={isDeleted} text='Successfully Deleted!' color='success' timeout />

        <Button onClick={() => setRedirectTo(emailCreateTemplateLink)}>Create Template</Button>

        <Table borderless hover responsive striped style={{ display: 'table' }}>
            <thead>
                <tr>
                    <th>#</th>
                    <th>Template</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                {React.Children.toArray(
                    templateList.map((t, tIndex) =>
                        <tr>
                            <td scope="row">{tIndex + 1}</td>
                            <td scope="row">{renderTemplateDetailsCol(t._id, templateList, userList)}</td>
                            <td scope="row">{renderActionsCol(t)}</td>
                        </tr>)
                )}
            </tbody>
        </Table>
    </EmailLayout >

    function renderActionsCol({ _id }) {
        return <>
            <Button onClick={() => setRedirectTo(getEmailEditTemplateLink(_id))}>Edit</Button>
            <Button
                style={{
                    backgroundColor: '#ff000024',
                    color: '#dc35459c',
                }} onClick={async () => {
                    if (window.confirm('Delete Template?')) {
                        await deleteEmailTemplate(_id, (res) => {
                            const newTemplateList = templateList.filter(t => t._id !== _id)
                            setTemplateList(newTemplateList)
                            setIsDeleted(true)
                        }, renderError)
                    }
                }}>Delete</Button>
        </>
    }
}

export default EmailTemplateList;